<div
  class="relative p-[10px] border-2 border-solid border-transparent transition-border duration-300 ease-in-out hover:!border-2 hover:!border-solid hover:!border-primary w-[100%] cursor-pointer"
  [id]="'pagemodule' + content.id"
  [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }"
  [ngClass]="{
    '!border-2 !border-solid !border-primary': isSelectedModule,
  }">
  <div>
    <div
      class="text-center font-bold mb-5"
      [attr.style]="buildStyle('text', titleItem?.styles?.text)">
      {{ titleItem?.value?.text }}
    </div>

    @if (counterItem) {
      <div
        class=" flex gap-3 p-3 items-center justify-between text-white"
        [ngStyle]="{
          background: state === 'safe' ? counterItem.styles?.counter?.safeCountColor : state === 'alert' ? counterItem.styles?.counter?.alertCountColor : state === 'critical' ? counterItem.styles?.counter?.criticalCountColor : '#000000'
        }">
        <div class="flex gap-3 items-center">
          <span class="pi pi-clock"></span>
          <div>
            <small>Expiration Date</small>
            @if (expirationDate) {
              <div class="w-fit font-bold">{{ expirationDate | date:'MM/dd/yyyy' }}</div>
            }
            @else {
              <div class="w-fit font-bold">No expiration KDE found</div>
            }
          </div>
        </div>
        <div>
          @if (expirationDate) {
            <span
              class="p-2 bg-white text-sm"
              [ngStyle]="{
                color: state === 'safe' ? counterItem.styles?.counter?.safeCountColor : state === 'alert' ? counterItem.styles?.counter?.alertCountColor : state === 'critical' ? counterItem.styles?.counter?.criticalCountColor : '#000000'
              }"
              >{{ daysLeftInExpiration > 0 ? 'Expires in ' + daysLeftInExpiration + ' day' + (daysLeftInExpiration === 1 ? '' : 's') : 'Expired' }} </span
            >
          }
        </div>
      </div>
    }
  </div>
</div>
